import BaseObjectStore from './base-object.store';

class ErTagStore extends BaseObjectStore {
  constructor(props) {
    super(props);
    this.name = 'erTag';
  }

  resetAllFields() {
    this.resetAllBaseFields();
  }
}

export default new ErTagStore();
